import { useState, useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import CheckBox from "./form/checkbox";
import toast, { Toaster } from 'react-hot-toast';

import { TimePicker } from 'antd';
const format = 'HH:mm';

const Search = () => {

    const [types, setTypes] = useState([]); // stores types to search
    const [geos, setGeos] = useState([]); // stores geos to search
    const [reliabilitys, setReliabilitys] = useState([]); // stores reliability to search

    const [words, setWords] = useState([])
    const [word, setWord] = useState('')

    const [reportName, setReportName] = useState('')

    const [time, setTime] = useState('')
    const [timeString, setTimeString] = useState('')
    const [timeCheckbox, setTimeCheckbox] = useState(false)


    const { setAlertClassName } = useOutletContext();
    const { setAlertMessage } = useOutletContext();
    const { setUserInfo } = useOutletContext();
    const { userInfo } = useOutletContext();

    const [errors, setErrors] = useState([]); // stores errors from frotnend

    const navigate = useNavigate();
    const { jwtToken } = useOutletContext();

    const notifyWordLimit = () => toast('Words limit is reached!', {
        duration: 1500,
        position: 'top-center',

        // Styling
        style: {
            border: '1px solid #0d6efd',
            padding: '16px',
            color: '#0d6efd',
        },
        className: '',


        // Custom Icon
        //icon: '',

        // Change colors of success/error/loading icon
        iconTheme: {
            primary: '#000',
            secondary: '#fff',
        },

        // Aria
        ariaProps: {
            role: 'status',
            'aria-live': 'polite',
        },
    });

    const notifyWordRequired = () => toast('At least one word must be added!', {
        duration: 1500,
        position: 'top-center',

        // Styling
        style: {
            border: '1px solid #0d6efd',
            padding: '16px',
            color: '#0d6efd',
        },
        className: '',


        // Custom Icon
        //icon: '',

        // Change colors of success/error/loading icon
        iconTheme: {
            primary: '#000',
            secondary: '#fff',
        },

        // Aria
        ariaProps: {
            role: 'status',
            'aria-live': 'polite',
        },
    });

    const notifySymbolLimit = () => toast('Lenght of a single word must be between 3 and 50 symbols!', {
        duration: 1500,
        position: 'top-center',

        // Styling
        style: {
            border: '1px solid #0d6efd',
            padding: '16px',
            color: '#0d6efd',
        },
        className: '',


        // Custom Icon
        //icon: '',

        // Change colors of success/error/loading icon
        iconTheme: {
            primary: '#000',
            secondary: '#fff',
        },

        // Aria
        ariaProps: {
            role: 'status',
            'aria-live': 'polite',
        },
    });

    const notifyReportNameLimit = () => toast('Lenght of Report name must be between 3 and 50 symbols!', {
        duration: 1500,
        position: 'top-center',

        // Styling
        style: {
            border: '1px solid #0d6efd',
            padding: '16px',
            color: '#0d6efd',
        },
        className: '',


        // Custom Icon
        //icon: '',

        // Change colors of success/error/loading icon
        iconTheme: {
            primary: '#000',
            secondary: '#fff',
        },

        // Aria
        ariaProps: {
            role: 'status',
            'aria-live': 'polite',
        },
    });

    const notifyReportNameEmpty = () => toast('Please, set report name!', {
        duration: 1500,
        position: 'top-center',

        // Styling
        style: {
            border: '1px solid #0d6efd',
            padding: '16px',
            color: '#0d6efd',
        },
        className: '',


        // Custom Icon
        //icon: '',

        // Change colors of success/error/loading icon
        iconTheme: {
            primary: '#000',
            secondary: '#fff',
        },

        // Aria
        ariaProps: {
            role: 'status',
            'aria-live': 'polite',
        },
    });

    const notifyTypeChecked = () => toast('Choose at least one source type!', {
        duration: 1500,
        position: 'top-center',

        // Styling
        style: {
            border: '1px solid #0d6efd',
            padding: '16px',
            color: '#0d6efd',
        },
        className: '',


        // Custom Icon
        //icon: '',

        // Change colors of success/error/loading icon
        iconTheme: {
            primary: '#000',
            secondary: '#fff',
        },

        // Aria
        ariaProps: {
            role: 'status',
            'aria-live': 'polite',
        },
    });

    const notifyGeoChecked = () => toast('Choose at least one source location!', {
        duration: 1500,
        position: 'top-center',

        // Styling
        style: {
            border: '1px solid #0d6efd',
            padding: '16px',
            color: '#0d6efd',
        },
        className: '',


        // Custom Icon
        //icon: '',

        // Change colors of success/error/loading icon
        iconTheme: {
            primary: '#000',
            secondary: '#fff',
        },

        // Aria
        ariaProps: {
            role: 'status',
            'aria-live': 'polite',
        },
    });

    const notifyReliabilityChecked = () => toast('Choose at least one source reliability level!', {
        duration: 1500,
        position: 'top-center',

        // Styling
        style: {
            border: '1px solid #0d6efd',
            padding: '16px',
            color: '#0d6efd',
        },
        className: '',


        // Custom Icon
        //icon: '',

        // Change colors of success/error/loading icon
        iconTheme: {
            primary: '#000',
            secondary: '#fff',
        },

        // Aria
        ariaProps: {
            role: 'status',
            'aria-live': 'polite',
        },
    });

    const notifyTimeChecked = () => toast('You marked schedule checkbox, but did not choose the time', {
        duration: 1500,
        position: 'top-center',

        // Styling
        style: {
            border: '1px solid #0d6efd',
            padding: '16px',
            color: '#0d6efd',
        },
        className: '',


        // Custom Icon
        //icon: '',

        // Change colors of success/error/loading icon
        iconTheme: {
            primary: '#000',
            secondary: '#fff',
        },

        // Aria
        ariaProps: {
            role: 'status',
            'aria-live': 'polite',
        },
    });

    useEffect(() => {
        // check if the token exists
        if (jwtToken === "") {
            navigate("/");
            return
        }

        // headers for request
        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + jwtToken); // put jwtToken to Auth header

        // options for request
        const requestOptions = {
            method: "GET",
            headers: headers,
            credentials: "include"
        }

        fetch(`${process.env.REACT_APP_BACKEND}/api/ar/query-options`, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                if (data.error) {
                    console.log(data.message)
                } else {

                    setAlertClassName("d-none"); // hide alert if it was
                    setAlertMessage("");

                    const typeWithChecks = [];
                    data.type.forEach(g => {
                        typeWithChecks.push({ checked: false, type: g });
                    })
                    setTypes(typeWithChecks);

                    const geoWithChecks = [];
                    data.geo.forEach(g => {
                        geoWithChecks.push({ checked: false, geo: g });
                    })
                    setGeos(geoWithChecks);

                    const reliabilityWithChecks = [];
                    data.reliability.forEach(g => {
                        reliabilityWithChecks.push({ checked: false, reliability: g });
                    })
                    setReliabilitys(reliabilityWithChecks);
                }
            })
            .catch(err => {
                console.log(err);
            });
    }, [jwtToken, navigate, setAlertClassName, setAlertMessage]);

    // check type
    const handeleTypeCheck = (value, type) => {
        let newValue = !value
        setTypes(prevState =>
            prevState.map(item =>
                item.type === type
                    ? { ...item, checked: newValue }
                    : item
            )
        )
    }

    // check geo
    const handeleGeoCheck = (value, geo) => {
        let newValue = !value
        setGeos(prevState =>
            prevState.map(item =>
                item.geo === geo
                    ? { ...item, checked: newValue }
                    : item
            )
        )
    }

    // check reliability
    const handeleReliabilityCheck = (value, reliability) => {
        let newValue = !value
        setReliabilitys(prevState =>
            prevState.map(item =>
                item.reliability === reliability
                    ? { ...item, checked: newValue }
                    : item
            )
        )
    }

    // add Word to search
    const handleAddWord = (event) => {

        event.preventDefault();

        let newValue = event.target[0].value

        if (newValue === "") {
            return
        }

        if (newValue.length < 3 || newValue.length > 50) {
            notifySymbolLimit();
            return
        }
        // user can currently search no more than N words within the same report
        if (words.length >= userInfo.wordsToSearchLimit) {
            notifyWordLimit();
            return
        }

        setWords([...words, newValue])

        setWord("");
    }

    // delete Word from search
    const handleDelWord = (index) => {
        const newWords = [
            ...words.slice(0, index),
            ...words.slice(index + 1)
        ];
        setWords(newWords);
    }

    // set word to search
    const handleInputChange = (event) => {
        setWord(event.target.value);
    };

    // set report name
    const handleReportNameChange = (event) => {
        setReportName(event.target.value);
    }

    const handleSubmit = (event) => { // receive event 
        event.preventDefault();

        let errors = [];

        let required = [
            { field: words, name: "words" },
        ]

        // check if fields are not empty
        required.forEach(function (obj) {
            if (obj.field.length <= 0) {
                notifyWordRequired();
                errors.push(obj.name);
                return
            }
        })


        // check if at least one type is checked---
        // tmp storage for checked types
        let tmpTypesArr = []

        // iterate over types and choose checked
        types.forEach(function (item) {
            if (item.checked === true) {
                tmpTypesArr.push(item.type)
            }
        })

        // check if type is checked
        if (tmpTypesArr.length === 0) {
            notifyTypeChecked();
            errors.push("types");
            return
        }

        // check if at least one geo is checked---
        // tmp storage for checked geos
        let tmpGeosArr = []

        // iterate over geos and choose checked
        geos.forEach(function (item) {
            if (item.checked === true) {
                tmpGeosArr.push(item.geo)
            }
        })

        // check if geo is checked
        if (tmpGeosArr.length === 0) {
            notifyGeoChecked();
            errors.push("geos");
            return
        }

        // check if at least one reliability is checked---
        // tmp storage for checked reliability
        let tmpReliabilityArr = []

        // iterate over reliability and choose checked
        reliabilitys.forEach(function (item) {
            if (item.checked === true) {
                tmpReliabilityArr.push(item.reliability)
            }
        })

        // check if reliability is checked
        if (tmpReliabilityArr.length === 0) {
            notifyReliabilityChecked();
            errors.push("reliability");
            return
        }

        // chek if reportName set
        if (reportName.length === 0) {
            notifyReportNameEmpty();
            errors.push("reportName");
            return
        }

        // check if report name requirements
        if (reportName.length < 3 || reportName > 50) {
            notifyReportNameLimit();
            errors.push("reportName")
            return
        }

        // check if schedule is checked
        if (timeCheckbox === true && timeString.length <= 0) {
            notifyTimeChecked();
            errors.push("timeChecked")
            return
        }

        // set global errors
        setErrors(errors);

        // if there has been any  error, return false
        if (errors.length > 0) {
            return false;
        }

        // save results in db
        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + jwtToken);

        let method = "POST";

        let requestBody = {
            report_name: reportName,
            words: words,
            types: tmpTypesArr,
            geos: tmpGeosArr,
            reliability: tmpReliabilityArr,
            time: timeString,
            activate_schedule: timeCheckbox
        }

        let requestOptions = {
            body: JSON.stringify(requestBody),
            method: method,
            headers: headers,
            credentials: "include",
        }

        // make a request
        fetch(`${process.env.REACT_APP_BACKEND}/api/ar/search`, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                if (data.error) {
                    setAlertClassName("alert-danger"); // show error class
                    setAlertMessage(data.message);
                    return
                } else {
                    setAlertClassName("d-none"); // hide alert if it was
                    setAlertMessage("");
                    setUserInfo({
                        ...userInfo,
                        tokens: data.tokens
                    })
                    navigate("/reports-storage");
                }
            })
            .catch(err => {
                console.log(err)
            })
    }

    // set schedule time
    const handleSetTime = (time, timeString) => {
        setTime(time);
        setTimeString(timeString);
    };

    // set time checkbox
    const handeleTimeChebox = () => {
        setTimeCheckbox(!timeCheckbox);
    }

    return (
        <div>

            <Toaster />

            <h2 className="text-center">Search in sources</h2>

            <h4>Report name</h4>
            <input type="text" className="form-control" onChange={handleReportNameChange} value={reportName} placeholder="Set report name" aria-label="report name" aria-describedby="button-addon2" required />
            <hr />


            <h4>Words to search</h4>
            {words.length} / {userInfo.wordsToSearchLimit}

            <form id="add-word-form" className="mt-3" onSubmit={(event) => handleAddWord(event)}>
                <div className="input-group mb-1">
                    <input type="text" className="form-control" onChange={handleInputChange} value={word} placeholder="Add word you want to search" aria-label="word to search" aria-describedby="button-addon2" />
                    <button className="btn btn-primary" type="text" id="button-addon2">Add</button>
                </div>
            </form>
            {words &&
                <ul className="list-group">
                    <div>
                        {words.map((word, index) => (
                            <div key={index} >
                                <h5>
                                    <span key={index} className="badge text-primary fw-normal">
                                        {word}
                                        <button key={index} id={word} type="button" className="btn rounded-pill" onClick={() => handleDelWord(index)}>
                                            <i key={index} className="bi bi-x-circle"></i>
                                        </button>
                                    </span>
                                </h5>
                            </div>
                        ))}
                    </div>
                </ul>
            }
            <hr />
            <form onSubmit={handleSubmit}>
                <h4>Source type</h4>
                {types &&
                    <>
                        {Array.from(types).map((g, index) =>
                            <CheckBox
                                title={g.type}
                                name={"type"}
                                key={index}
                                id={"type-" + index}
                                onChange={() => handeleTypeCheck(g.checked, g.type)}
                                value={g.id}
                                checked={g.checked}
                            />
                        )}
                    </>
                }
                <hr />
                <h4>Source location</h4>
                {geos &&
                    <>
                        {Array.from(geos).map((g, index) =>
                            <CheckBox
                                title={g.geo}
                                name={"geo"}
                                key={index}
                                id={"geo-" + index}
                                onChange={() => handeleGeoCheck(g.checked, g.geo)}
                                value={g.id}
                                checked={g.checked}
                            />
                        )}
                    </>
                }
                <hr />
                <h4>Source reliability</h4>
                {reliabilitys &&
                    <>
                        {Array.from(reliabilitys).map((g, index) =>
                            <CheckBox
                                title={g.reliability}
                                name={"reliability"}
                                key={index}
                                id={"reliability-" + index}
                                onChange={() => handeleReliabilityCheck(g.checked, g.reliability)}
                                value={g.id}
                                checked={g.checked}
                            />
                        )}
                    </>
                }
                <hr />

                <div className="mb-2">
                    <CheckBox
                        title={"Check, if you want to receive the report on a regular basis"}
                        name={"timeCheck"}
                        id={"timeCheck"}
                        onChange={handeleTimeChebox}
                        checked={timeCheckbox}
                    />
                </div>

                <TimePicker
                    onChange={handleSetTime}
                    format={format}
                    value={time}
                />
                <hr />
                <input onSubmit={handleSubmit}
                    type="submit"
                    className="btn btn-primary mt-2"
                    value="Search"
                />
            </form>
        </div >
    );
}

export default Search;